(function () {
    'use strict';

    angular
        .module('franchiser.directives')
        .directive('unitFranchisees', UnitFranchisees);

    /** @ngInject */
    function UnitFranchisees($rootScope, $httpParamSerializer, HelperService, PATHS_FRANCHISER, ROUTES, ReportDownloadService) {
        function UnitFranchiseesDirectiveController($scope) {
            const vm = this;

            // Watch on show tab
            let removeWatchShow = $scope.$watch('vm.show', (newValue, oldValue) => {
                if (newValue)
                    init();
            })

            $scope.$on('$destroy', () => {
                removeWatchShow();
            })

            vm.configureReportDownload = () => {
                const parameters = {
                    UnitId: vm.unitData.Id
                };

                return ReportDownloadService.download('franchisees-history-report', parameters);
            }

            function setFranchisees() {
                vm.franchisees = vm.unitData.FranchiseeHistory.map(elem => {
                    let franchisee = {
                        Id: elem.Id,
                        Name: elem.Name,
                        Active: elem.Active
                    };

                    // Phone
                     if (elem.FranchiseeHistory_Phone && elem.FranchiseeHistory_Phone.length) {
                        franchisee.Phones = elem.FranchiseeHistory_Phone.map(phone => {
                            phone.PhoneComplete = String(phone.Phone.Code.concat(phone.Phone.Number)).replace(/-/g, '');

                            return phone;
                        });
                     }

                    // Email
                    if (elem.FranchiseeHistory_Email && elem.FranchiseeHistory_Email.length) {
                        franchisee.Emails = elem.FranchiseeHistory_Email.map(email => {

                            email.Email = email.Email.Address;

                            return email;
                        })
                    }


                    // CPF
                    if (elem.FranchiseeHistory_Document && elem.FranchiseeHistory_Document.length) {
                        const document = elem.FranchiseeHistory_Document.find(document => document.DocumentTypeId == 1);

                        if (document)
                            franchisee.Cpf = document.Document.Code;
                    }

                    // Address
                    if (elem.FranchiseeHistory_Address && elem.FranchiseeHistory_Address.length) {
                        const address = elem.FranchiseeHistory_Address[0];

                        franchisee.Address = address.Address;
                    }

                    // Birthdate
                    if (elem.Birthdate)
                        franchisee.BirthdateFormatted = moment(elem.Birthdate).format('DD/MM/YYYY');

                    return franchisee;
                });

                HelperService.stopLoading('.loading-holder');
            }

            function init() {
                vm.canUserCreate = $rootScope.canUserCreate;
                vm.canUserEdit = $rootScope.canUserEdit;

                HelperService.startLoading('.loading-holder');

                setFranchisees();
            }
        }

        return {
            bindToController: true,
            controller: UnitFranchiseesDirectiveController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/directives/unit-franchisees/unit-franchisees.html`,
            scope: {
                unitData: '=',
                show: '='
            }
        }
    }
}());